import {
  RIGHTS_IS_CREATE,
  RIGHTS_IS_DELETE,
  RIGHTS_IS_EDIT,
  RIGHTS_IS_EDIT_ALL,
  RIGHTS_CRM_TASKS,
} from '@app/constants';
import { useAccessRights } from '@app/hooks';

export const useTasksAccess = () => {
  const { hasUserRight: rightToDeleteTask } = useAccessRights(
    RIGHTS_CRM_TASKS,
    RIGHTS_IS_DELETE
  );
  const { hasUserRight: rightToEditTask } = useAccessRights(
    RIGHTS_CRM_TASKS,
    RIGHTS_IS_EDIT
  );
  const { hasUserRight: rightToEditAllTask } = useAccessRights(
    RIGHTS_CRM_TASKS,
    RIGHTS_IS_EDIT_ALL
  );
  const { hasUserRight: rightToCreateTask } = useAccessRights(
    RIGHTS_CRM_TASKS,
    RIGHTS_IS_CREATE
  );

  return {
    rightToDeleteTask,
    rightToEditTask,
    rightToEditAllTask,
    rightToCreateTask,
  };
};
